export const siteData = {
  brand: "BIGGIE POPPINS",
  monogram: "BP",
  eyebrow: "Working home base · V2",
  tagline: "Builder working across AI, systems, media, and commerce.",
  intro:
    "A home base for selected work, ideas in progress, and the things holding my attention right now.",
  ctas: {
    primary: { label: "See current work", href: "#portfolio" },
    secondary: { label: "Find me on Instagram", href: "https://instagram.com/BiggiePoppins" }
  },
  socials: [
    { name: "X", url: "https://x.com/BiggiePoppins", icon: "Twitter" },
    { name: "Instagram", url: "https://instagram.com/BiggiePoppins", icon: "Instagram" },
    { name: "Crafty Systems Labs", url: "https://github.com/Crafty-Systems-Labs", icon: "Github" }
  ],
  signalStrip: ["AI / automation", "commerce", "creative systems", "selected writing"],
  about: {
    title: "QUIET SIGNAL, REAL WORK",
    paragraphs: [
      "I like tools that sharpen judgment, brands with staying power, and systems that make good work easier to repeat.",
      "This site is intentionally lean. No fake case studies. No inflated claims. Just a cleaner picture of what I’m building, what I care about, and where my head is at."
    ],
    principles: [
      {
        title: "Taste over noise",
        body: "If it feels hollow, trendy, or overbuilt, it probably gets cut."
      },
      {
        title: "Systems that compound",
        body: "I care about work that gets more valuable as the reps stack."
      },
      {
        title: "Built in public, selectively",
        body: "Enough signal to show the direction. Not enough leakage to hand over the blueprint."
      }
    ]
  },
  portfolio: [
    {
      id: 1,
      title: "Prediction and decision tools",
      description:
        "Interfaces and workflows for making fast, better calls when the signal is noisy and the market is moving.",
      category: "Software",
      status: "Building",
      tags: ["analysis", "markets", "decision systems"]
    },
    {
      id: 2,
      title: "Ritual-based brand exploration",
      description:
        "Consumer ideas with identity, repeat behavior, and room for a real moat instead of generic commodity energy.",
      category: "Brand",
      status: "Shaping",
      tags: ["brand", "offer", "retention"]
    },
    {
      id: 3,
      title: "Automation and agent workflows",
      description:
        "Small systems that remove friction, tighten execution, and turn scattered work into something reusable.",
      category: "Systems",
      status: "Active",
      tags: ["automation", "ops", "agents"]
    },
    {
      id: 4,
      title: "Writing and idea capture",
      description:
        "Notes around leverage, discipline, incentives, and building a body of work that actually compounds.",
      category: "Writing",
      status: "In progress",
      tags: ["writing", "strategy", "clarity"]
    },
    {
      id: 5,
      title: "Photography and visual direction",
      description:
        "A visual lane for documenting what feels true, cinematic, and sharp without overexplaining it.",
      category: "Creative",
      status: "Intermittent",
      tags: ["photo", "identity", "art direction"]
    },
    {
      id: 6,
      title: "Operator OS",
      description:
        "Personal systems for energy, consistency, and focus so the work has a stronger engine behind it.",
      category: "Discipline",
      status: "Always on",
      tags: ["habits", "health", "execution"]
    }
  ],
  blog: [
    {
      id: 1,
      title: "What AI is actually good for in a small operation",
      excerpt:
        "Not replacing judgment. Compressing busywork, tightening loops, and giving yourself better leverage.",
      category: "Notes in progress"
    },
    {
      id: 2,
      title: "Brands people return to versus brands they scroll past",
      excerpt:
        "Ritual, identity, timing, and why most offers feel interchangeable long before they fail.",
      category: "Notes in progress"
    },
    {
      id: 3,
      title: "Decision-making when the information is incomplete",
      excerpt:
        "How to move with enough conviction to learn, but not so much ego that you ignore the market.",
      category: "Notes in progress"
    }
  ],
  contact: {
    title: "BEST PLACE TO FIND ME",
    blurb:
      "For the quickest signal, start with Instagram or X. If you want the broader body of work, Crafty Systems Labs is the cleaner archive.",
    availability: [
      "Interesting product and systems conversations",
      "Brand direction with actual commercial intent",
      "Select collaborations where the taste bar is high"
    ]
  }
};
